// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"No-z","slideIn":"Oo-z"};